module.exports = __webpack_public_path__ + "static/media/pause.db7a8934.svg";